import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BadgeCheck } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

const norm = (p) => p.replace(/\D/g, "").slice(-10);

export function usePhoneStatus() {
  const api = useApi();
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/phone/status").then((r) => setS(r.data)).catch(() => setS({ enabled: false, verified_phone: "" }));
  }, [api]);
  return [s, setS];
}

export function PhoneOtp({ phone, status, setStatus }) {
  const api = useApi();
  const [sentTo, setSentTo] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  if (!status?.enabled) return null;
  const p = norm(phone);
  if (p.length !== 10) return null;
  if (status.verified_phone === p) {
    return <p className="flex items-center gap-1.5 text-xs font-medium text-emerald-700" data-testid="phone-verified"><BadgeCheck className="h-4 w-4" />Mobile number verified</p>;
  }
  const send = async () => {
    setBusy(true);
    try {
      await api.post("/phone/otp", { phone: p });
      setSentTo(p);
      toast.success(`OTP sent to ${p}`);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const verify = async () => {
    setBusy(true);
    try {
      const r = await api.post("/phone/verify", { phone: p, code });
      setStatus({ ...status, verified_phone: r.data.verified_phone });
      toast.success("Mobile number verified");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="rounded-2xl bg-orange-50/60 p-4 text-sm" data-testid="phone-otp">
      {sentTo !== p ? (
        <div className="flex flex-wrap items-center justify-between gap-2">
          <span className="text-neutral-700">Verify your mobile number with a one-time code.</span>
          <button type="button" onClick={send} disabled={busy} data-testid="phone-otp-send" className="rounded-full bg-[#FF5A00] px-4 py-2 font-semibold text-white disabled:opacity-60">{busy ? "Sending…" : "Send OTP"}</button>
        </div>
      ) : (
        <div className="flex flex-wrap items-center gap-2">
          <input value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" autoComplete="one-time-code" placeholder="6-digit code" data-testid="phone-otp-code"
            className="w-36 rounded-xl border border-black/10 bg-white px-3 py-2 font-mono tracking-widest outline-none focus:ring-2 focus:ring-[#FF5A00]" />
          <button type="button" onClick={verify} disabled={busy || code.length !== 6} data-testid="phone-otp-verify" className="rounded-full bg-[#FF5A00] px-4 py-2 font-semibold text-white disabled:opacity-60">Verify</button>
          <button type="button" onClick={send} disabled={busy} data-testid="phone-otp-resend" className="text-xs font-semibold text-[#FF5A00]">Resend</button>
        </div>
      )}
    </div>
  );
}
